import { inject, Injectable, signal } from '@angular/core';
import { LoggerService } from './logger.service';

@Injectable({
  providedIn: 'root',
})
export class SidebarService {
  private readonly _isOpen = signal(true);
  private logger = inject(LoggerService);

  readonly isOpen = this._isOpen.asReadonly();

  toggle(): void {
    this._isOpen.update((current) => !current);
    this.logger.info(`Sidebar is now ${this._isOpen() ? 'open' : 'closed'}`);
  }
}
